import React from 'react';
import { Box, Grid, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import img from './img/wpimage.png';

const TextSection = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #e3f2fd, #ffffff)', // Updated background to linear gradient
            }}
        >
            <Box
                sx={{
                    padding: { xs: 3, sm: 4, md: 6 },
                    minHeight: { xs: 'auto', md: '90vh' }, // Ensures full height on larger screens
                    display: 'flex',
                    flexDirection: 'column', // Stack children vertically
                    alignItems: 'center', // Center content horizontally
                    justifyContent: 'center',
                    width: { xl: "74%", lg: "90%", md: "90%", sm: "90%" },
                }}
            >
                {/* Main Heading - Moved to the very top */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '28px', sm: '36px', md: '40px' },
                        color: '#1A1A3D',
                        textAlign: { xs: 'center', md: 'left' },
                        mb: 4,
                        width: '100%', // Ensure it spans the full width
                    }}
                >
                    Qualify and engage leads with Vertex Suite WhatsApp marketing software
                </Typography>

                {/* Two-column layout using Grid */}
                <Grid container spacing={4} alignItems={{ xs: 'center', md: 'center' }}>

                    {/* Left Column: Features List */}
                    <Grid
                        item
                        xs={12}
                        md={6}

                        sx={{
                            paddingLeft: { xs: 2, md: 4 },                                  // Increased left spacing
                            // border: { xs: "2px solid red", md: "2px solid green" },
                            paddingRight: { xs: 2, md: 4 },
                            order: { xs: 2, md: 1 },                                 // Ensure equal spacing
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: { xs: '20px', sm: '24px', md: '28px' },
                                color: '#1A1A3D',
                                mb: 2,
                                textAlign: { xs: 'center', md: 'left' },
                            }}
                        >
                            Campaign builder and audience targeting
                        </Typography>
                        <List>
                            {[
                                'Audience segmentation to send targeted messages',
                                'Ready-to-use templates for easy setup',
                                'Rich and wide variety of media to increase engagement',
                                'Broadcast and drip marketing to run personalized campaigns.',
                            ].map((text, index) => (
                                <ListItem key={index} sx={{ padding: 0, mb: 1 }}>
                                    <ListItemIcon>
                                        <CheckCircleOutlineIcon sx={{ color: '#4A90E2', fontSize: { xs: '24px', md: '28px' } }} /> {/* Adjusted icon size */}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={text}
                                        primaryTypographyProps={{
                                            variant: 'body1',
                                            fontSize: { xs: '16px', sm: '18px', md: '20px' },
                                            color: '#1A1A3D',
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>

                    {/* Right side Image Section */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            paddingLeft: { xs: 2, md: 4 }, // Increased right spacing
                            paddingRight: { xs: 2, md: 4 }, // Ensure equal spacing
                            order: { xs: 1, md: 2 },
                        }}
                    >
                        <Box
                            component="img"
                            src={img}
                            alt="Vertex Suite WhatsApp Marketing"
                            sx={{
                                width: { xs: '100%', md: '90%' }, // Slightly decreased image size
                                // border: { xs: "2px solid red", md: "2px solid green" },
                                height: 'auto',
                                borderRadius: 2,
                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                objectFit: 'contain',
                                display: 'block',
                                margin: '0 auto', // Center the image on smaller screens
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>

    );
};

export default TextSection;